export const IS_BROWSER = process.env.BROWSER_MODE === 'true';
